<div class="full-layout">
  <div class="sidebar-backdrop" [class.is-open]="sidebarOpen" (click)="closeSidebar()"></div>

  <aside class="sidebar customer-card" [class.is-open]="sidebarOpen">
    <div class="brand">
      <div class="brand-mark">
        <img class="brand-logo brand-logo-main" src="assets/img/logo.png" alt="ULC Terminal">
      </div>
      <div class="brand-meta">
        <span class="brand-kicker">ULC Terminal</span>
        <strong>{{ "customer_portal" | translate }}</strong>
      </div>
    </div>

    <nav class="nav-list">
      <a *ngFor="let item of navItems" [routerLink]="item.route" routerLinkActive="active" (click)="closeSidebar()">{{ item.key | translate }}</a>
    </nav>
  </aside>

  <div class="main-panel">
    <header class="topbar">
      <div class="topbar-leading">
        <button type="button" class="nav-toggle" (click)="toggleSidebar()">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div class="toolbar">
        <div ngbDropdown class="language-dropdown">
          <button type="button" class="language-toggle btn-inline-loader" ngbDropdownToggle [disabled]="languageBusy">
            <span *ngIf="languageBusy" class="button-spinner is-dark"></span>
            <span class="lang-flag" [ngClass]="'flag-' + currentLanguage.flag"></span>
            <span>{{ currentLanguage.key | translate }}</span>
          </button>
          <div ngbDropdownMenu class="language-menu">
            <button
              type="button"
              ngbDropdownItem
              *ngFor="let lang of languageOptions"
              (click)="switchLanguage(lang.code)"
              [class.active]="lang.code === activeLanguage"
              [disabled]="languageBusy">
              <span class="lang-flag" [ngClass]="'flag-' + lang.flag"></span>
              <span>{{ lang.key | translate }}</span>
            </button>
          </div>
        </div>
        <div ngbDropdown class="account-dropdown">
          <button type="button" class="account-toggle" ngbDropdownToggle>
            <span class="account-avatar">{{ displayName.charAt(0) }}</span>
            <span class="account-copy">
              <strong>{{ displayName }}</strong>
            </span>
          </button>
          <div ngbDropdownMenu class="account-menu">
            <div class="account-menu-section">
              <a
                *ngFor="let item of accountItems"
                ngbDropdownItem
                [routerLink]="item.route"
                (click)="closeSidebar()"
                class="account-link">
                <i class="menu-icon bi" [ngClass]="item.icon" aria-hidden="true"></i>
                <span>{{ item.key | translate }}</span>
              </a>
            </div>

            <div class="account-menu-divider"></div>

            <div class="account-menu-section nav-shortcuts">
              <a
                *ngFor="let item of shortcutNavItems"
                ngbDropdownItem
                [routerLink]="item.route"
                (click)="closeSidebar()"
                class="account-link">
                <i class="menu-icon bi" [ngClass]="item.icon" aria-hidden="true"></i>
                <span>{{ item.key | translate }}</span>
              </a>
            </div>

            <div class="account-menu-divider"></div>

            <div class="account-menu-section">
              <button type="button" ngbDropdownItem class="account-link logout-item btn-inline-loader" (click)="logout()" [disabled]="logoutBusy">
                <span *ngIf="logoutBusy" class="button-spinner is-dark"></span>
                <i class="menu-icon bi bi-box-arrow-right" aria-hidden="true"></i>
                <span>{{ "logout" | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>

    <main class="content-area">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
